import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7425 12.9913C23.8377 13.1446 23.9026 13.2566 23.9372 13.3202C24.0713 13.5671 23.9843 13.8785 23.7429 14.0157C23.5015 14.1528 23.1971 14.0639 23.063 13.817C23.0377 13.7704 22.9828 13.6756 22.8983 13.5396C22.7549 13.3084 22.5819 13.0498 22.3796 12.7705C21.7996 11.9697 21.1029 11.1681 20.2908 10.4205C18.5003 8.77258 16.4391 7.63861 14.1035 7.21178C16.0879 8.05541 17.4831 10.057 17.4831 12.3926C17.4831 15.4898 15.0282 18.0007 12.0001 18.0007C8.97195 18.0007 6.51709 15.4898 6.51709 12.3926C6.51709 10.057 7.91225 8.05541 9.89668 7.21178C7.5611 7.63861 5.49984 8.77258 3.70943 10.4205C2.89728 11.1681 2.20055 11.9697 1.62056 12.7705C1.41826 13.0498 1.24533 13.3084 1.10186 13.5396C1.0174 13.6756 0.962475 13.7704 0.937164 13.817C0.803051 14.0639 0.498647 14.1528 0.257259 14.0157C0.0158703 13.8785 -0.0710941 13.5671 0.0630184 13.3202C0.0975974 13.2566 0.162458 13.1446 0.257668 12.9913C0.413658 12.74 0.600079 12.4612 0.817029 12.1616C1.43489 11.3086 2.17561 10.4563 3.04051 9.66023C5.52191 7.37627 8.51091 6.00073 12.0001 6.00073C15.4893 6.00073 18.4783 7.37627 20.9597 9.66023C21.8246 10.4563 22.5653 11.3086 23.1832 12.1616C23.4001 12.4612 23.5865 12.74 23.7425 12.9913ZM12.0001 7.80725C9.52387 7.80725 7.51709 9.85955 7.51709 12.3926C7.51709 14.9249 9.52423 16.9779 12.0001 16.9779C14.4759 16.9779 16.4831 14.9249 16.4831 12.3926C16.4831 9.85955 14.4763 7.80725 12.0001 7.80725Z"/>
    </svg>
  );
}
